import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class AuthRequestPayload extends RequestPayload {
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/requests/auth-request-payload.ts